import { render } from "./VODStorageStat.vue?vue&type=template&id=28e685b8"
import script from "./VODStorageStat.vue?vue&type=script&setup=true&lang=js"
export * from "./VODStorageStat.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/VOD/VODStorageStat.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "28e685b8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('28e685b8', __exports__)) {
    api.reload('28e685b8', __exports__)
  }
  
  module.hot.accept("./VODStorageStat.vue?vue&type=template&id=28e685b8", () => {
    api.rerender('28e685b8', render)
  })

}


export default __exports__